import {
  DATA_CONNECTOR_SAVE_XANO_FIELDS_BEGIN,
  DATA_CONNECTOR_SAVE_XANO_FIELDS_SUCCESS,
  DATA_CONNECTOR_SAVE_XANO_FIELDS_FAILURE,
  DATA_CONNECTOR_SAVE_XANO_FIELDS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
export function saveXanoFields(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_SAVE_XANO_FIELDS_BEGIN,
    });
    const { projectId, version, savefieldsobj, upid } = args
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xano/update-tables/${upid}`,
        savefieldsobj,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_SAVE_XANO_FIELDS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_SAVE_XANO_FIELDS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveXanoFieldsError() {
  return {
    type: DATA_CONNECTOR_SAVE_XANO_FIELDS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_SAVE_XANO_FIELDS_BEGIN:
      return {
        ...state,
        saveXanoFieldsPending: true,
        saveXanoFieldsError: null,
      };

    case DATA_CONNECTOR_SAVE_XANO_FIELDS_SUCCESS:
      return {
        ...state,
        saveXanoFieldsPending: false,
        saveXanoFieldsError: null,
      };

    case DATA_CONNECTOR_SAVE_XANO_FIELDS_FAILURE:
      return {
        ...state,
        saveXanoFieldsPending: false,
        saveXanoFieldsError: action.data.error,
      };

    case DATA_CONNECTOR_SAVE_XANO_FIELDS_DISMISS_ERROR:
      return {
        ...state,
        saveXanoFieldsError: null,
      };

    default:
      return state;
  }
}
